import React from 'react';
export const Generic24 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.23736 1L7.06153 1.17735L6.22973 2.76232L5.96825 2.93887H3V5.35927H4.63179L4.77715 5.53509L3 8.93121V10.6937H3.00048H4.76248L4.93847 10.5164L5.77011 8.93137L6.03159 8.75499H9V6.33443H7.36821L7.22293 6.15748L9 2.76264V1H7.23736Z",
        fill: "currentColor"
    }));
Generic24.displayName = 'Generic24';
export default Generic24;

//# sourceMappingURL=24x24.js.map